// extracted by mini-css-extract-plugin
module.exports = {"detailsMap":"EventDetailsLocation_detailsMap__ukv8G"};